<template>
  <main class="home">

      
      <section id="intro" class="section section--align-bottom intro">
          <div class="container">
            <h1 id="intro-text">Our name <br class="small-break">is <br class="large-break"> our <br class="small-break">promise</h1>
          </div>
      </section>


      <section  id="about"  class="section section--no-padding about">
        
          <!-- <ModelViewer :bodyScrollBar="this.bodyScrollBar" class="model3DViewer"/> -->

          <div id="graphic-letters"><span>O</span><span>A</span></div>
          <div id="over-and-above">Ov<br>er+<br>Abo<br>ve</div>
          

          <div class="about--one container">
              <h2 class="about-headline">We go over and above to deliver creative solutions with spark, substance and serious smarts.</h2>
          </div>

           <!-- <div class="about--two container">
              <h2>We listen. We learn.<br>We listen some more.</h2>
              <p class="paragraph">With years of industry experience, we’re known for producing work of the highest standard and pursue every challenge with curiosity and excitement. We specialise in bringing brands to life through all advertising touchpoints and go beyond the expected.</p>
          </div> -->

          <div class="about--three container">
              <div class="about--three-item">
                <!-- <img src="/assets/images/figures/o.svg" alt=""> -->
                <h2>Partnership<br> over profit</h2>
                <p class="paragraph paragraph--small">We value client relationships and team culture above any monetary amount. Life experience and rewarding projects only reinforce this time and time again. We don’t work for free but we do work hard. Our communication is honest and down-to-earth, our standards are high and our service fees are fair.</p>
              </div>
              <div class="about--three-item"> 
                <!-- <img src="/assets/images/figures/o.svg" alt=""> -->
                <h2>Particular<br> not precious</h2>
                <p class="paragraph paragraph--small">Dedicated to our craft and appreciative of stunning design, we’ve honed our skills over many years and know what works. From a straight forward breifing process to the big reveal, we’re busy making the magic look effortless. We’re street smart artists and developers who know how to design.</p>
              </div>
              <div class="about--three-item"> 
                <!-- <img src="/assets/images/figures/o.svg" alt=""> -->
                <h2>Flexibility<br> above all</h2>
                <p class="paragraph paragraph--small">We’re here to save you time and grow your business. We don’t believe in over-complicating tasks, so we keep our processes simple, our work innovative and our coffee machine warm. If you’re in need of some design guidance…just ask! We’re ready to solve the largest of challenges with a smile.</p>
              </div>
          </div>

       

          <div class="curtains">
            <div class="curtains__left"></div>
            <div class="curtains__right"></div>
          </div>
      </section>
     





      <section id="work" class="horizontal">
          <div class="pin-wrap">
            <!-- <span class="dash dash--right"></span> -->
            <div class="horizontal__info"></div>
            <div class="animation-wrap to-right">

              <div id="item0" class="item">
                <div class="item__image">
                  <video id="showreel-video-1" autoplay="" loop="" playsinline="" muted="" preload="auto" class="js-video-autoplay video-inline__preview"> <source src="/assets/video/o-a-preston-high.mp4" type="video/mp4"></video>
                  <div class="item__detail">
                    <h4>Preston High School</h4>
                    <p class="paragraph paragraph--small">A highly collaborative relationship with Preston High School has allowed us to create a brand that resonates with the local community, teachers, and students. From logo development, website, print collateral, advertising, and signage. A proud legacy has begun.</p>  
                  </div>      
                </div>
              </div>

              <div id="item1" class="item">
                <div class="item__image">
                  <video id="showreel-video-2" autoplay="" loop="" playsinline="" muted="" preload="auto" class="js-video-autoplay video-inline__preview"> <source src="/assets/video/o-a-epic.mp4" type="video/mp4"></video>
                  <div class="item__detail">
                    <h4>EPIC</h4>
                    <p class="paragraph paragraph--small">Refreshing the EPIC brand included everything from new styling, new thinking, and a new mascot - the hero of an illustrated children’s book collection. A truly rewarding project involving a wide range of printed collateral, illustration, production, promotions, and digital.</p>  
                  </div>  
                </div>
              </div>

              <div id="item2" class="item">
                <div class="item__image">
                  <video id="showreel-video-3" autoplay="" loop="" playsinline="" muted="" preload="auto" class="js-video-autoplay video-inline__preview"> <source src="/assets/video/o-a-pwsavic.mp4" type="video/mp4"></video>
                  <div class="item__detail">
                    <h4>Prader-Willi Syndrome</h4>
                    <p class="paragraph paragraph--small">The association required a digital presence to raise awareness and communicate important information to families raising children with Prader-Willi Syndrome. Our tailored platform allows organisers to easily manage their content and bring much-needed support to families.</p>  
                  </div>  
                </div>
              </div>

              <div id="item3" class="item">
                <div class="item__image">
                  <video id="showreel-video-4" autoplay="" loop="" playsinline="" muted="" preload="auto" class="js-video-autoplay video-inline__preview"> <source src="/assets/video/o-a-baag.mp4" type="video/mp4"></video>
                  <div class="item__detail">
                    <h4>Bulleen Art and Garden</h4>
                    <p class="paragraph paragraph--small">A truly unique business with a cult following requires a shift in styling subtly integrated into its brand. Expressing the artistic qualities of BAAG, we have modernised their corporate identity and continue to gradually update their range of products.</p>  
                  </div>  
                </div>
              </div>

             
 
             
          </div>
        </div>
      </section>

      
  </main>
</template>

<script>

//import PortfolioItem from '@/components/elements/PortfolioItem.vue'
import * as $ from 'jquery'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
//import Scrollbar from 'smooth-scrollbar';
//import ModelViewer from '@/components/viewers/ModelViewer.vue'


export default {

  data() {
    return {

      resizeTimer: 0,

      folioSection: '',
      folioPinWrap: '',
      folioAnimWrap: '',
      folioAnimInfo: '',
      
      folioTween: '',
      folioInfoTween: '',
      scrollTrigger: '',

      scrollPositionY: 0,
      folioPinWrapWidth: 0,
      folioWidth: 0,
      windowWidth: 0,
      fromValue: 0,
      toValue: 0,
    }
  },

  props: {
    bodyScrollBar: null,
    testname: String
  },

  watch: { 
    bodyScrollBar: function(newVal, oldVal) { // watch it
      this.onScrollbarActive(newVal, oldVal);
    }
  },

  components: {
    //ModelViewer,
  },


  methods: {
            

    // ==========================================================
    // WINDOW RESIZE LISTENER
    // ==========================================================

    onWindowResize: function() {


      this.folioWidth               = $('.animation-wrap').width();
      this.windowWidth              = $(window).innerWidth();
      this.toValue                  = -(this.folioWidth - this.windowWidth);

      this.folioTween.vars.x = this.toValue;      
      this.folioTween.invalidate();

      //console.log("this.folioWidth",this.folioWidth);
      

    },

    // ==========================================================
    // SMOOTH SCROLLBAR ACTIVATED
    // ==========================================================

    onScrollbarActive: function() {

      let bodyScroll      = this.bodyScrollBar;

      ScrollTrigger.scrollerProxy(document.body, {
        scrollTop(value) {
          if (arguments.length) {
            bodyScroll.scrollTop = value;
          }
          return bodyScroll.scrollTop;
        },
        getBoundingClientRect() {
          return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
        }
      });
      
      this.bodyScrollBar.setPosition(0, 0);
      this.bodyScrollBar.track.xAxis.element.remove();
      this.bodyScrollBar.addListener(ScrollTrigger.update);
      this.bodyScrollBar.addListener(({ offset }) => {  
        
        this.scrollPositionY = offset.y;

        this.bodyScrollBar.scrollLeft = 0;

        if (this.scrollPositionY > 100) {
            $('#logo').removeClass('grow');
        } else {
            $('#logo').addClass('grow');
        }

        if (this.folioScrolling ) {

          this.folioAnimWrap.css({"top": this.scrollPositionY + "px"});
          this.folioAnimInfo.css({"top": 'calc(' + this.scrollPositionY + 'px + 70vh)'}); 

          var tweenPosition       = this.folioTween.progress();
          var itemsTweenPosition  = tweenPosition/.33333333;
          var itemPositiion       = (itemsTweenPosition*this.windowWidth/2);
          var windowWidth         = this.windowWidth;

          $( ".item__image" ).each(function( index ) {
            $( this ).css('transform',  'translateX('+ ((windowWidth/-2*index)+itemPositiion) +'px)');
          });

          //console.log(tweenPosition);

          var vid1 = document.getElementById("showreel-video-1");
          var vid2 = document.getElementById("showreel-video-2");
          var vid3 = document.getElementById("showreel-video-3");
          var vid4 = document.getElementById("showreel-video-4");


          if (tweenPosition < 0.25) {
              $( ".horizontal__info" ).html($('#item0 .item__detail').html());
              vid1.play();
              vid2.pause();
              vid3.pause();
              vid4.pause();
          } else if (tweenPosition < 0.5) {
              $( ".horizontal__info" ).html($('#item1 .item__detail').html());
              vid1.pause();
              vid2.play();
              vid3.pause();
              vid4.pause();
          } else if (tweenPosition < 0.75) {
              $( ".horizontal__info" ).html($('#item2 .item__detail').html());
              vid1.play();
              vid2.pause();
              vid3.play();
              vid4.pause();
          } else {
              $( ".horizontal__info" ).html($('#item3 .item__detail').html());
              vid1.pause();
              vid2.pause();
              vid3.pause();
              vid4.play();
          }

        } else {

          this.folioAnimWrap.css({ "top": "" });	  
          this.folioAnimInfo.css({"top": ""});

        }

      });

      window.addEventListener( 'resize', this.onWindowResize, false );

      this.initAnimations();

    },


    // ==========================================================
    // initAnimations
    // ==========================================================

    initAnimations: function() {

      this.folioSection            = $('section.horizontal');
      this.folioAnimWrap           = $('.animation-wrap');
      this.folioAnimInfo           = $('.horizontal__info');

      this.folioWidth               = $('.animation-wrap').width();
      this.windowWidth              = $(window).innerWidth();
      this.fromValue                = 0;
      this.toValue                  = -(this.folioWidth - this.windowWidth);

      //console.log("initAnimations this.folioWidth", this.folioWidth);
      $( ".horizontal__info" ).html($('#item0 .item__detail').html());


      this.folioTween = gsap.fromTo(
          '.animation-wrap',
          { x: this.fromValue }, 
          { x: this.toValue, overwrite: true, ease: "none" }
      );

        this.folioInfoTween = gsap.from(
          '.horizontal__info', 
          {
            scrollTrigger: { trigger: '.horizontal' }, 
            translateX: "-500px", 
            duration: 1, 
            ease: "expo.out"
          }
        );


      this.aboutTween = gsap.from(
        '.about-headline', 
        {
          scrollTrigger: { trigger: '.about-headline', start: "top bottom", end: "top center", }, 
          opacity: 0,
          duration: 2, 
          x: -100,
          ease: "expo.out"
        }
      );


      this.aboutTween = gsap.from(
        '.about--three', 
        {
          scrollTrigger: { trigger: '.about--three' }, 
          opacity: 0,
          duration: 2, 
          y: 200,
          ease: "expo.out"
        }
      );

      if ($(window).width() > 768) {

        this.aboutTween = gsap.from(
          '.about-headline', 
          {
            scrollTrigger: { trigger: '.about-headline', start: "top bottom", end: "bottom top", scrub: true }, 
            y: 200,
            ease: "expo.out"
          }
        );

        this.aboutTween = gsap.from(
          '.about--two', 
          {
            scrollTrigger: { trigger: '.about--two', start: "top bottom", end: "bottom top", scrub: true }, 
            y: 200,
            ease: "expo.out"
          }
        );

      }

      gsap.timeline({
        scrollTrigger: {
          trigger: "#intro-text",
          start: "center top",
          end: "+=500",
          scrub: true
        }
      })
      .to(".curtains__left",  { translateX: "-60px" }, 0)
      .to(".curtains__right", { translateX: "60px" }, 0)

   
      if ($(window).width() > 768) {

          this.scrollTrigger = ScrollTrigger.create({

              animation: this.folioTween,
              trigger: '.horizontal',					
              start: "top top",
              end: "+="+this.folioWidth,
              pin: true,
              scrub: true,  
              invalidateOnRefresh: true,

              onUpdate: self => {	
                if(self.isActive) {
                  this.folioScrolling = true;
                }
              },
              onLeave: () => {
                this.folioScrolling = false;
              },
              onLeaveBack: () => {
                this.folioScrolling = false;
              }
            }); 

            var progress = 0;
            var scrollTrig = this.scrollTrigger;

            ScrollTrigger.addEventListener("refreshInit", function() {
              progress = scrollTrig.scroll() / ScrollTrigger.maxScroll(window);
            });
            ScrollTrigger.addEventListener("refresh", function() {
              scrollTrig.end = scrollTrig.start + $('.animation-wrap').width();
              scrollTrig.scroll(progress * ScrollTrigger.maxScroll(window));
            });

        }
    }


  },

  updated: function() {


  },
  mounted: function() {
    

  }

}
</script>


